import { render, staticRenderFns } from "./dashboard.html?vue&type=template&id=4fb16516&scoped=true&external"
import script from "./dashboard.js?vue&type=script&lang=js&external"
export * from "./dashboard.js?vue&type=script&lang=js&external"
import style0 from "./dashboard.scss?vue&type=style&index=0&id=4fb16516&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb16516",
  null
  
)

export default component.exports